import { render, staticRenderFns } from "./InventoryLessProduct.vue?vue&type=template&id=f935637c&scoped=true&"
import script from "./InventoryLessProduct.vue?vue&type=script&lang=js&"
export * from "./InventoryLessProduct.vue?vue&type=script&lang=js&"
import style0 from "./InventoryLessProduct.vue?vue&type=style&index=0&id=f935637c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f935637c",
  null
  
)

export default component.exports